import { LargeAmountDetail } from 'interfaces'

export const getLargeAmountValueAndUnit = (
  amount: number,
): LargeAmountDetail => {
  if (Math.abs(amount) >= 1.0e9) {
    return { value: amount / 1.0e9, unit: 'B' }
  } else if (Math.abs(amount) >= 1.0e6) {
    return { value: amount / 1.0e6, unit: 'M' }
  } else if (Math.abs(amount) >= 1.0e3) {
    return { value: amount / 1.0e3, unit: 'K' }
  } else {
    return { value: amount, unit: null }
  }
}
